import React, { memo } from 'react'

import { ArrowRight } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number } from 'prop-types'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import SubscriptionEntryPoints from 'Pods/Shared/Constants/subscriptionEntryPoints'
import { setSubscriptionEntry } from 'Pods/Shared/Utils/subscriptionEntry'

const SUBSCRIPTION_PATH = '/subscription'

// Mirrors Subscription::DOWNLOAD_LIMIT, the server value behind pageConfig's
// threeDStudioSubscriptionMonthlyModels.
const DEFAULT_MONTHLY_MODELS = 25

const handleLinkClick = () => {
  setSubscriptionEntry(SubscriptionEntryPoints.SEARCH_PRICE_FILTER_UPSELL)
}

function SubscriptionPromo({ monthlyModels = DEFAULT_MONTHLY_MODELS }) {
  const translate = useTranslate()

  return (
    <div className="price-filter__subscription-promo">
      <div className="price-filter__subscription-promo-text">
        <p className="price-filter__subscription-promo-title cgt-body-base-semibold">
          {translate('search_page.filters.price.subscription_promo.title')}
        </p>
        <p className="price-filter__subscription-promo-description cgt-body-base">
          {translate('search_page.filters.price.subscription_promo.text', { limit: monthlyModels })}
        </p>
      </div>
      <a
        href={SUBSCRIPTION_PATH}
        target="_blank"
        rel="noopener noreferrer"
        className="price-filter__subscription-promo-link cgt-link-primary"
        onClick={handleLinkClick}
        data-subscription-entry={SubscriptionEntryPoints.SEARCH_PRICE_FILTER_UPSELL}
      >
        {translate('search_page.filters.price.subscription_promo.cta')}
        <ArrowRight
          width="16"
          height="16"
          className="price-filter__subscription-promo-arrow"
          aria-hidden="true"
          focusable="false"
        />
      </a>
    </div>
  )
}

SubscriptionPromo.propTypes = {
  monthlyModels: number,
}

export default memo(SubscriptionPromo)
